import { styled } from 'styled-components';
export const PinSearchMainContainer = styled.div`
  width: 100%;
  display: -webkit-flex;
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
  padding-left: 60px;
  margin: auto;
  margin-top: 5rem;
  //box-sizing: border-box;
  @media screen and (max-width: 500px) {
    padding-left: 0;
    padding-right: 0px;
    flex-direction: column-reverse;
    gap: 0;
    margin: auto;
    margin-top: 3.5rem;
  }
`;
export const PinSearchInnerContainer = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  align-items: flex-end;
  gap: 32px;
  flex-shrink: 0;
  align-self: stretch;
  max-width: 600px;
  @media screen and (max-width: 500px) {
    width: 100%;
    padding: 0;
  }
`;
export const PinSearchFormContainer = styled.div`
  display: flex;
  padding: 80px 48px 80px 48px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  align-self: stretch;
  @media screen and (max-width: 500px) {
    padding: 24px 24px 40px 24px;
  }
`;
export const PinSearchImgWrapper = styled.div`
  width: 50%;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const SearchBackgroundDiv = styled.div<{ $imageUrl: any }>`
  width: auto;
  height: 100%;
  background-image: url(${(props: any) => props.$imageUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media screen and (max-width: 500px) {
    height: 25vh;
  }
`;
